import api from '@/libs/axios'

export default {
  async activationLearn(payload) {
    let response = await api.post('/admin/activation-learn', payload)
    return response
  },
}
